<template>
  <div class="settings-container">
    <div class="title-container">
      <div class="title" v-if="allSettings">Settings</div>
      <div class="title" v-else-if="profileSettings">Profile Settings</div>
      <img class="avishkaar-icon" src="https://images.avishkaar.cc/misc/profile/images/avishkaar-icon.png" alt="Avishkaar" />
    </div>
    <div class="settings-items-container" v-if="allSettings">
      <div class="settings-item" @click="profileSettings=true; allSettings=false;">
        <div class="sub-title">Profile</div>
        <img class="dropdown-right" src="https://images.avishkaar.cc/misc/profile/utility/dropdown-right-icon.png" alt="Go" />
      </div>
    </div>
    <div class="profile-settings-container" v-else-if="profileSettings">
      <div class="theme-container">
        <div class="theme-items">
          <div class="title">Theme</div>
          <div class="theme-item-container">
            <input type="radio" class="theme-color theme-color-blue" value="blue" v-model="settingsData.themeSelected" @click="themeEditing=true" />
            <input type="radio" class="theme-color theme-color-orange" value="orange" v-model="settingsData.themeSelected" @click="themeEditing=true" />
            <input type="radio" class="theme-color theme-color-pink" value="pink" v-model="settingsData.themeSelected" @click="themeEditing=true" />
            <input type="radio" class="theme-color theme-color-green" value="green" v-model="settingsData.themeSelected" @click="themeEditing=true" />
            <input type="radio" class="theme-color theme-color-yellow" value="yellow" v-model="settingsData.themeSelected" @click="themeEditing=true" />
          </div>
        </div>
        <button v-if="themeEditing" class="theme-save" @click="updateThemeInProfileSettings"><img :src="tickIcon" alt="Save" /><div class="highlight">Save</div></button>
      </div>
      <div class="item-page">
        <div class="sub-title">Bio Page</div>
        <div class="item-item" :class="kitsEditing && 'item-item-editing'">
          <div class="content-container">
            <div class="content">Kits Owned</div>
            <button class="item-item-edit" v-if="kitsEditing" @click="updateKitsPrivacyInProfileSettings"><img :src="tickIcon" alt="Save" /><div class="highlight">Save</div></button>
            <button class="item-item-edit" v-else @click="kitsEditing = true"><img :src="editIcon" alt="Edit" /><div class="highlight">{{settingsData.kitsPrivacy == 'public' ? 'Public' : 'Only Me' }}</div></button>
          </div>
          <div class="editing" v-if="kitsEditing">
            <div class="content">Select your privacy option :</div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="public" id="publicKits" v-model="settingsData.kitsPrivacy" />
              <label class="privacy-label" for="publicKits">Public</label>
            </div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="private" id="privateKits" v-model="settingsData.kitsPrivacy" />
              <label class="privacy-label" for="privateKits">Only Me</label>
            </div>
          </div>
        </div>
        <div class="item-item" :class="personaEditing && 'item-item-editing'" v-if="profileData.user_type == 'student'">
          <div class="content-container">
            <div class="content">Innovator Persona</div>
            <button class="item-item-edit" v-if="personaEditing" @click="updatePersonaPrivacyInProfileSettings"><img :src="tickIcon" alt="Save" /><div class="highlight">Save</div></button>
            <button class="item-item-edit" v-else @click="personaEditing=true"><img :src="editIcon" alt="Edit" /><div class="highlight">{{settingsData.personaPrivacy == 'public' ? 'Public' : 'Only Me' }}</div></button>
          </div>
          <div class="editing" v-if="personaEditing">
            <div class="content">Select your privacy option :</div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="public" id="publicPersona" v-model="settingsData.personaPrivacy" />
              <label class="privacy-label" for="publicPersona">Public</label>
            </div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="private" id="privatePersona" v-model="settingsData.personaPrivacy" />
              <label class="privacy-label" for="privatePersona">Only Me</label>
            </div>
          </div>
        </div>
      </div>
      <div class="item-page">
        <div class="sub-title">My Projects Page</div>
        <div class="item-item" :class="projectUploadsEditing && 'item-item-editing'">
          <div class="content-container">
            <div class="content">Project Uploads</div>
            <button class="item-item-edit" v-if="projectUploadsEditing" @click="updateProjectUploadPrivacyInProfileSettings"><img :src="tickIcon" alt="Save" /><div class="highlight">Save</div></button>
            <button class="item-item-edit" v-else @click="projectUploadsEditing=true"><img :src="editIcon" alt="Edit" /><div class="highlight">{{settingsData.projectUploadPrivacy == 'public' ? 'Public' : 'Only Me' }}</div></button>
          </div>
          <div class="editing" v-if="projectUploadsEditing">
            <div class="content">Select your privacy option :</div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="public" id="publicProjects" v-model="settingsData.projectUploadPrivacy" />
              <label class="privacy-label" for="publicProjects">Public</label>
            </div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="private" id="privateProjects" v-model="settingsData.projectUploadPrivacy" />
              <label class="privacy-label" for="privateProjects">Only Me</label>
            </div>
          </div>
        </div>
        <div class="item-item" :class="collaboratorsEditing && 'item-item-editing'" v-if="profileData.user_type == 'parent'">
          <div class="content-container">
            <div class="content">Collaborations</div>
            <button class="item-item-edit" v-if="collaboratorsEditing" @click="updateCollaboratorsPrivacyInProfileSettings"><img :src="tickIcon" alt="Save" /><div class="highlight">Save</div></button>
            <button class="item-item-edit" v-else @click="collaboratorsEditing=true"><img :src="editIcon" alt="Edit" /><div class="highlight">{{settingsData.collaboratorsPrivacy == 'public' ? 'Public' : 'Only Me' }}</div></button>
          </div>
          <div class="editing" v-if="collaboratorsEditing">
            <div class="content">Select your privacy option :</div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="public" id="publicCollab" v-model="settingsData.collaboratorsPrivacy" />
              <label class="privacy-label" for="publicCollab">Public</label>
            </div>
            <div class="privacy-item">
              <input class="privacy" type="radio" value="private" id="privateCollab" v-model="settingsData.collaboratorsPrivacy" />
              <label class="privacy-label" for="privateCollab">Only Me</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "MySettings",
  data() {
    return {
      allSettings: true,
      profileSettings: false,
      themeEditing: false,
      kitsEditing: false,
      personaEditing: false,
      projectUploadsEditing: false,
      collaboratorsEditing: false,
      tickIcon: "https://images.avishkaar.cc/misc/profile/utility/tick-orange-icon.png",
      editIcon: "https://images.avishkaar.cc/misc/profile/utility/edit-icon-orange.png",
      settingsData: {
        themeSelected: "blue",
        kitsPrivacy: "public",
        personaPrivacy: "public",
        projectUploadPrivacy: "public",
        collaboratorsPrivacy: "public",
      },
    };
  },
  computed: {
    ...mapGetters({userProfileSettings:"getuserProfileSettings", profileData: "getUserProfileData"}),
  },
  created() {
    if (this.$cookies.get("userAccess") !== null) {
      this.fetchUserProfileSettings();
    }
  },
  watch: {
    userProfileSettings: function (newVal) {
      if (newVal != null) {
        if (newVal.color != null) this.settingsData.themeSelected = newVal.color;
        if (newVal.registered_product != null) this.settingsData.kitsPrivacy = newVal.registered_product;
        if (newVal.persona != null) this.settingsData.personaPrivacy = newVal.persona;
        if (newVal.projects != null) this.settingsData.projectUploadPrivacy = newVal.projects;
      }
    },
  },
  methods: {
    ...mapActions(["fetchUserProfileSettings", "updateUserProfileSettings"]),
    updateThemeInProfileSettings() {
      this.updateUserProfileSettings({
        type: 'color',
        value: this.settingsData.themeSelected}).then(
          this.themeEditing=false
        );
    },
    updateKitsPrivacyInProfileSettings() {
      this.updateUserProfileSettings({
        type: 'registered_product',
        value: this.settingsData.kitsPrivacy}).then(
          this.kitsEditing=false
        );
    },
    updatePersonaPrivacyInProfileSettings() {
      this.updateUserProfileSettings({
        type: 'persona',
        value: this.settingsData.personaPrivacy}).then(
          this.personaEditing=false
        );
    },
    updateProjectUploadPrivacyInProfileSettings() {
      this.updateUserProfileSettings({
        type: 'projects',
        value: this.settingsData.projectUploadPrivacy}).then(
          this.projectUploadsEditing=false
        );
    },
    updateCollaboratorsPrivacyInProfileSettings() {
      this.collaboratorsEditing=false
      // this.updateUserProfileSettings({
      //   type: 'collaborator',
      //   value: this.settingsData.projectUploadPrivacy}).then(
      //     this.collaboratorsEditing=false
      //   );
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 75%;
    .avishkaar-icon {
      margin: 1rem 0;
    }
  }
  .settings-items-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 75%;
    .settings-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f4f4f4;
      width: 100%;
      height: 12.5vh;
      .dropdown-right {
        margin: 0 2.5%;
      }
    }
    .settings-item:hover {
      cursor: pointer;
    }
  }
  .profile-settings-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 75%;
    .theme-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f4f4f4;
      width: 100%;
      height: 12.5vh;
      .theme-items {
        display: flex;
        width: 80%;
        align-items: center;
        .title {
          font-size: 1.75rem;
        }
        .theme-item-container {
          display: flex;
          align-items: center;
          margin-left: 5%;
          justify-content: space-between;
          width: 45%;
          .theme-color {
            appearance: none;
            border-radius: 50%;
            width: 50px;
            height: 50px;
          }
          .theme-color:checked {
            border: 2px solid #ffffff;
            box-shadow: 0 2px 6px 0 rgb(0, 0, 0, 16%);
            background-image: url("https://images.avishkaar.cc/misc/profile/utility/tick-icon.png");
            background-position: center;
            background-repeat: no-repeat;
          }
          .theme-color:hover {
            cursor: pointer;
            background-image: url("https://images.avishkaar.cc/misc/profile/utility/tick-icon.png");
            background-position: center;
            background-repeat: no-repeat;
          }
          .theme-color-blue {
            background-color: #57b9ff;
          }
          .theme-color-orange {
            background-color: #ffab5e;
          }
          .theme-color-pink {
            background-color: #fc6161;
          }
          .theme-color-green {
            background-color: #84f030;
          }
          .theme-color-yellow {
            background-color: #ffdb5a;
          }
        }
      }
      .theme-save {
        display: flex;
        align-items: center;
        outline: none;
        justify-content: space-between;
        .highlight {
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 500;
          margin: 0 0.5rem;
          color: #f36f2e;
        }
      }
    }
    .item-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      .sub-title {
        font-weight: 600;
        display: flex;
        font-size: 1.5rem;
        align-items: center;
        border-bottom: 1px solid #f4f4f4;
        width: 100%;
        height: 12.5vh;
      }
      .item-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #f4f4f4;
        width: 100%;
        height: 8vh;
        transition: height 0.3s;
        .content-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .content {
            font-family: Poppins;
            font-size: 1.125rem;
            font-weight: 500;
          }
          .item-item-edit {
            display: flex;
            align-items: center;
            outline: none;
            justify-content: space-between;
            .highlight {
              font-family: Roboto;
              font-size: 1rem;
              font-weight: 500;
              margin: 0 0.5rem;
              color: #f36f2e;
            }
          }
        }
        .editing {
          display: flex;
          align-items: center;
          width: 100%;
          .content {
            color: #8d8d8d;
          }
          .privacy-item {
            display: flex;
            align-items: center;
            margin-left: 1rem;
            .privacy {
              appearance: none;
              border-radius: 50%;
              width: 15px;
              height: 15px;
              border: 1px solid #8d8d8d;
            }
            .privacy:checked {
              border-color: #f36f2e;
              padding: 2px;
              background-clip: content-box;
              background-color: #f36f2e;
            }
            .privacy:hover {
              cursor: pointer;
              border-color: #f36f2e;
              background-color: #f36f2e;
            }
            .privacy:checked ~ .privacy-label {
              color: #f36f2e;
            }
            .privacy:hover ~ .privacy-label {
              color: #f36f2e;
            }
            .privacy-label {
              font-weight: 500;
              margin: 0 0.5rem;
              color: #8d8d8d;
            }
            .privacy-label:hover {
              cursor: pointer;
            }
          }
        }
      }
      .item-item-editing {
        height: 15vh;
        justify-content: space-evenly;
        transition: height 0.3s;
      }
    }
  }
}
.title {
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
}
.sub-title {
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 500;
  color: #000000;
}
.content {
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
}
@media all and (max-width: 1150px) {
  .settings-container {
    .profile-settings-container {
      .theme-container {
        .theme-items {
          .theme-item-container {
            width: 80%;
          }
        }
      }
    }
  }
}
@media all and (max-width: 700px) {
  .settings-container {
    .title-container {
      width: 70%;
      margin-left: 10%;
      .avishkaar-icon {
        width: 45px;
        height: 61px;
        margin: 1rem;
        margin-right: 0;
      }
    }
    .settings-items-container {
      width: 70%;
      margin-left: 10%;
      .settings-item {
        height: 12.5vh;
        .dropdown-right {
          margin: 0 2.5%;
        }
      }
    }
    .profile-settings-container {
      width: 70%;
      margin-left: 10%;
      .theme-container {
        align-items: flex-start;
        justify-content: space-between;
        height: 17.5vh;
        .theme-items {
          align-items: flex-start;
          justify-content: space-between;
          flex-direction: column;
          height: 100%;
          .title {
            font-size: 1.5rem;
          }
          .theme-item-container {
            margin-left: 0;
            margin-bottom: 0.5rem;
            width: 125%;
            .theme-color {
              margin-left: 0;
            }
          }
        }
        .theme-save {
          margin-top: 0.5rem;
        }
      }
      .item-page {
        .sub-title {
          height: 10vh;
        }
        .item-item {
          .editing {
            justify-content: space-between;
            .content {
              font-size: 0.875rem;
            }
            .privacy-item {
              margin-left: 0;
              .privacy {
                width: 12px;
                height: 12px;
              }
              .privacy-label {
                font-size: 0.875rem;
              }
            }
          }
        }
        .item-item-editing {
          height: 15vh;
        }
      }
    }
  }
  .title {
    font-size: 1.5rem;
  }
  .content {
    font-size: 1rem;
  }
}
@media all and (max-width: 500px) {
  .settings-container {
    .title-container {
      width: 90%;
      margin-left: 0;
    }
    .settings-items-container {
      width: 90%;
      margin-left: 0;
    }
    .profile-settings-container {
      width: 90%;
      margin-left: 0;
    }
  }
}
</style>